var _linearGradient, _linearGradient2, _linearGradient3, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 15.2357,
    x2: 8.09646,
    xlinkHref: "#a",
    y1: 7.67312,
    y2: 10.7902
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 16.8177,
    x2: 23.9441,
    xlinkHref: "#a",
    y1: 24.2786,
    y2: 21.1836
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.6647 15.2165-12.4572-12.0486-1.2075-1.1679-9.37731 9.0697-4.28743 4.1468c-.44701.4329-.44701 1.1341 0 1.567l8.56724 8.2862 5.0975 4.9303 9.3773-9.0697.1452-.1404 4.1422-4.0064c.4471-.4329.4471-1.1341 0-1.567zm-13.6647 4.9229-4.2798-4.1394 4.2798-4.1394 4.2798 4.1394z",
    fill: "#2684ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.9999 11.8606c-2.802-2.71053-2.8157-7.10066-.0305-9.8274l-9.36588 9.0549 5.09748 4.9303z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.2912 15.9888-4.2912 4.1504c1.3525 1.3074 2.1124 3.081 2.1124 4.9303 0 1.8494-.7599 3.623-2.1124 4.9304l9.3888-9.0808z",
    fill: "url(#c)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.5308231ca70c509cb3074180b517e1cd.svg";
export { ForwardRef as ReactComponent };